export default (transfers, passengers) => {
  if (transfers) {
    return transfers.map(transfer => {
      return {
        total: transfer.amount * passengers.length,
        description: transfer.description,
        type: transfer.type,
        code: transfer.code,
        mvapId: transfer.mvAssociatedProductId,
        productId: transfer.productId,
      }
    })
  }
}
